import React, {useEffect, useState, useContext} from "react";
import $ from 'jquery';
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { Scrollbar } from 'react-scrollbars-custom';
import userlogo from "./../../../Public/img/avatar-14.jpg";
import { AuthContext } from "../../../context/AuthContext";
import logo from "./../../../Public/img/logo-black.png";



const Sidebar = () =>{
    const navigate = useNavigate();
    const currenturl = useLocation();
    const {user, setUser} = useContext(AuthContext);

    /*const [loggedname, setLoggedName] = useState("");
    const [loggedroleid, setLoggedRoleID] = useState(0);
    const [loggedemail, setLoggedEmail] = useState("");*/

    const scrollstyle = {
                        height: 'auto',
                        width: '100%',
                        position: 'right',
                        size: '7px',
                        color: '#ccc',
                        wheelStep: 10,
                        touchScrollStep: 100,
                        };

    useEffect(() =>{

        //init();
		
        var $slimScrolls = $('.slimscroll');
        
        if($slimScrolls.length > 0) {
            
            var wHeight = $(window).height() - 60;
            $slimScrolls.height(wHeight);
            $('.sidebar .slimScrollDiv').height(wHeight);
            $(window).resize(function() {
                var rHeight = $(window).height() - 60;
                $slimScrolls.height(rHeight);
                $('.sidebar .slimScrollDiv').height(rHeight);
            });
        }
		

            $(document).on('mouseover', function(e) {
                e.stopPropagation();
                if ($('body').hasClass('mini-sidebar') && $('#toggle_btn').is(':visible')) {
                    var targ = $(e.target).closest('.sidebar, .header-left').length;
                    if (targ) {
                        $('body').addClass('expand-menu');
                        $('.subdrop + ul').slideDown();
                    } else {
                        $('body').removeClass('expand-menu');
                        $('.subdrop + ul').slideUp();
                    }
                    return false;
                }
            });

            if($('#btnFullscreen').length > 0) {
                document.getElementById('btnFullscreen').addEventListener('click', function() {
                    toggleFullscreen();
                });
            }
        

    }, []);

	const toggleFullscreen = () =>{
		if (!document.fullscreenElement) 
		{
			document.documentElement.requestFullscreen();
		} 
		else 
		{
			if (document.exitFullscreen) 
			{
				document.exitFullscreen();
			}
		}
	}

    const handleSignout = () =>{
        localStorage.removeItem('cpmstoken');
        //sessionStorage.removeItem('cpmstoken');
        localStorage.removeItem('userinfo');

        setUser(null);

        navigate('/sign-in', { replace: true });
    }

    return(
    <div className="sidebar" id="sidebar">
        <div class="crm-brand">
            <img src={logo} alt="Logo" />
        </div>
        <div className="sidebar-inner slimscroll">
            <Scrollbar style={scrollstyle}>
                <div id="sidebar-menu" className="sidebar-menu">                        
                    <ul className="crm-menu-list mt-3">
                        <li>
                            <Link to="/sales/dashboard" className={currenturl.pathname === '/sales/dashboard' ? 'active' : ''}>
                                <i className="ti ti-home me-2"></i>
                                <span>Dashboard</span>
                            </Link>
                        </li>

                        {/*<li>
                            <Link to="/sales/caller-mapping" className={currenturl.pathname === '/sales/caller-mapping' ? 'active' : ''}>
                                <i className="ti ti-brand-campaignmonitor me-2"></i>
                                <span>College Mapping</span>
                            </Link>
                        </li>
                                
                        <li>
                            <Link to="/sales/campaigns" className={currenturl.pathname === '/sales/campaigns' ? 'active' : ''}>
                                <i className="ti ti-brand-campaignmonitor me-2"></i>
                                <span>Campaigns</span>
                            </Link>
                        </li>*/}
                        <li>
                            <Link to="/sales/teams" className={currenturl.pathname === '/sales/teams' ? 'active' : ''}>
                                <i className="ti ti-users me-2"></i>
                                <span>Teams</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/sales/leads" className={currenturl.pathname === '/sales/leads' ? 'active' : ''}>
                                <i className="ti ti-users me-2"></i>
                                <span>Leads</span>
                            </Link>
                        </li>
                        {/*<li>
                            <Link to="/sales/lead/add" className={currenturl.pathname === '/sales/lead/add' ? 'active' : ''}>
                                <i className="ti ti-location-plus me-2"></i>
                                <span>Lead Add</span>
                            </Link>
                        </li>*/}     
                        <li>
                            <Link to="/sales/report" className={currenturl.pathname === '/sales/report' ? 'active' : ''}>
                                <i className="ti ti-chart-bar me-2"></i>
                                <span>Report</span>
                            </Link>
                        </li>
                        {/*<li>
                            <Link to="/sales/profile" className={currenturl.pathname === '/sales/profile' ? 'active' : ''}>
                                <i className="ti ti-address-book"></i>
                                <span>Profile</span>
                            </Link>
                        </li>
                        <li>
                            <NavLink to="/sales/activity-logs" activeClassName="active">
                                <i className="ti ti-logs"></i>
                                <span>Activity Log</span>
                            </NavLink>
                        </li>*/}
                    </ul>
                    <div class="crm-sidebar-bottom">
                        <div class="crm-logout-link" onClick={handleSignout}>
                            <i class="ti ti-power me-2"></i>
                            <span>Log out</span>
                        </div>
                    </div>
                </div>
            </Scrollbar>
        </div>
        
    </div>
    )
}

export default Sidebar;